/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Session_Chat_SendInputs */



/**
* | output |
* | --- |
* | "Send" |
*
* @param {Practice_Session_Chat_SendInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_session_chat_send = /** @type {((inputs?: Practice_Session_Chat_SendInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Session_Chat_SendInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Versturen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Envoyer")
	return /** @type {LocalizedString} */ ("Send")
});